import React from "react";

const ColorGrowingSpinner = ({ intensityLevels = [] }) => {
  return (
    <div className="color-growing-spinner">
      <div className=" spinner-wrapper">
        <div className="card-body card-buttons">
          {intensityLevels.map((opacity, index) => (
            <div
              key={index}
              className="spinner-grow m-2"
              role="status"
              style={{
                backgroundColor: `rgba(255, 155, 68, ${opacity})`,
                width: "1.5rem",
                height: "1.5rem",
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ColorGrowingSpinner;
